import { PropsWithChildren, useEffect } from "react";

import { markAppReady } from "./CustomerMetrics";

/** Wraps an app's root component and records when the app is on screen (its code has loaded and it has mounted). */
export const AppLoadTracker = ({ appId, children }: PropsWithChildren<{ appId: string }>) => {
    useEffect(() => markAppReady(appId), [appId]);
    return children;
};
